/*
 * @Author: Teemo Ding
 * @Date: 2021-10-27 17:20:18
 * @LastEditTime: 2022-06-01 15:57:50
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/WarehouseLocations/PickPackProcessSettings/index.tsx
 */
import { SizeFittingTable } from '@/src/components/Antd';
import {
  getPickPackSetting,
  savePickPackSetting,
} from '@/src/request/settings/logistics/pickPackSetting';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Spin, message } from 'antd';
import { get } from 'lodash';
import React, { useMemo } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

enum IPickPackSetting {
  AutoPicking = 'autoPicking',
  AutoPacking = 'autoPacking',
  AutoShipping = 'autoShipping',
}

const permissions = () => {
  const edit_pick_pack_process_settings = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.edit_pick_pack_process_settings,
      }),
    ],
  });
  return {
    edit_pick_pack_process_settings,
  };
};

const PickPackProcessSettings = ({ warehouseUuid }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { edit_pick_pack_process_settings } = permissions();
  const {
    loading: getPickPackSettingLoading,
    run: _getPickPackSetting,
    data: pickPackSettingList,
  } = useRequest(() => getPickPackSetting(warehouseUuid));

  const { loading: savePickPackSettingLoading, run: _savePickPackSetting } =
    useRequest((data) => savePickPackSetting(data), {
      manual: true,
      onSuccess: () => {
        message.success(getI18n('general.savesuccess'));
        _getPickPackSetting();
      },
    });

  const handleChangeStatus = (type, status) => {
    console.log('status: ', type, status);
    _savePickPackSetting({ ...pickPackSettingList, [type]: !status });
  };

  const pickPackSettingData = [
    {
      type: IPickPackSetting.AutoPicking,
      function: getI18n('storeLogistics.warehouseLocations.autoPicking'),
      status: get(pickPackSettingList, 'autoPicking', false),
      description: getI18n(
        'storeLogistics.warehouseLocations.autoPickingDescription',
      ),
    },
    {
      type: IPickPackSetting.AutoPacking,
      function: getI18n('storeLogistics.warehouseLocations.autoPacking'),
      status: get(pickPackSettingList, 'autoPacking', false),
      description: getI18n(
        'storeLogistics.warehouseLocations.autoPackingDescription',
      ),
    },
    {
      type: IPickPackSetting.AutoShipping,
      function: getI18n('storeLogistics.warehouseLocations.autoShipping'),
      status: get(pickPackSettingList, 'autoShipping', false),
      description: getI18n(
        'storeLogistics.warehouseLocations.autoShippingDescription',
      ),
    },
  ];
  // ? getI18n('general.enabled')
  // : getI18n('general.disabled'),

  const columns = useMemo(() => {
    return [
      {
        title: getI18n('storeLogistics.warehouseLocations.function'),
        dataIndex: 'function',
        default: true,
        key: 'function',
        minWidth: 128,
      },
      {
        title: getI18n('storeLogistics.warehouseLocations.status'),
        dataIndex: 'status',
        default: true,
        key: 'status',
        childGenerate: (text) => {
          return text
            ? getI18n('general.enabled')
            : getI18n('general.disabled');
        },
        minWidth: 128,
      },
      {
        title: getI18n('storeLogistics.warehouseLocations.functionDescription'),
        dataIndex: 'description',
        default: true,
        key: 'description',
        minWidth: 704,
      },
      {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'action',
        default: true,
        key: 'action',
        minWidth: 128,
        childGenerate: (text, record, index) => {
          return edit_pick_pack_process_settings ? (
            <div className={css.action}>
              <span
                className={record.status ? css.danger : css.primary}
                onClick={() => handleChangeStatus(record.type, record.status)}>
                {record.status
                  ? getI18n('storeLogistics.warehouseLocations.disable')
                  : getI18n('storeLogistics.warehouseLocations.enable')}
              </span>
            </div>
          ) : (
            <div></div>
          );
        },
      },
    ];
  }, [i18n]);

  return (
    <div>
      <Spin spinning={getPickPackSettingLoading || savePickPackSettingLoading}>
        <SizeFittingTable
          id='ShippingZoneTable'
          rowKey='type'
          pagination={false}
          dataSource={pickPackSettingData}
          className={css.shippingZoneTable}
          columns={columns}
          rowClassName={css.row}
        />
      </Spin>
    </div>
  );
};

export default PickPackProcessSettings;
